export const cmsEnv = {
  endpoint: process.env.GATSBY_CMS_API_ENDPOINT,
  token: process.env.GATSBY_CMS_API_TOKEN,
}
